/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import { MaterialIcon } from '../../MaterialIcon';

type ProductGridCardContentProps = {
  title?: string;
  metricPrefix?: string;
  metricPrimary?: string;
  metricSecondary?: string;
  badgeText?: string;
  showBadgeInfoIcon: boolean;
};

export const ProductGridCardContent = ({
  title,
  metricPrefix,
  metricPrimary,
  metricSecondary,
  badgeText,
  showBadgeInfoIcon,
}: ProductGridCardContentProps) => {
  // Single editor-chosen benefit rendered as one clean line (CMS-1858): the old
  // Benefits label | divider | rate-range | unit | (i) layout is replaced by the
  // product's prefix/value/unit joined into a single wrapping line.
  const benefitLine = [metricPrefix, metricPrimary, metricSecondary]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');

  if (!title && !benefitLine && !badgeText) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1 md:gap-spacing/gap/soft-6px">
      {title && (
        <h3
          className={classNames(
            'line-clamp-2 text-text/primary',
            badgeText
              ? 'mhg-alpha-typography-title-2'
              : 'mhg-alpha-typography-overline md:mhg-alpha-typography-title-2 md:h-14',
          )}
        >
          {title}
        </h3>
      )}

      {benefitLine && (
        <p className="border-l border-borders/default pl-spacing/padding/soft-12px mhg-alpha-caption text-text/secondary-lighter [word-break:break-word] line-clamp-3">
          {benefitLine}
        </p>
      )}

      {badgeText && (
        <div className="w-fit rounded-[4px] bg-fill/primary-light px-[6px] py-[2px] md:rounded-[6px] md:px-spacing/padding/soft-8px md:py-spacing/padding/soft-4px lg:rounded-radius/tooltip">
          <div className="flex items-center gap-1">
            <p className="text-fill/primary-dark mhg-alpha-typography-table-cell-strong">
              {badgeText}
            </p>
            {showBadgeInfoIcon && (
              <MaterialIcon
                icon="info"
                px={16}
                className="text-fill/primary-dark opacity-50 !text-[16px] md:!text-[18px]"
                aria-label="Additional info"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
